import * as React from "react";

import axios from "axios";

import { useLoader } from "../../Context/LoaderContext";

import { addSeparateur } from "../../Functions/separateur_chiffre";

import bgSidebarRight from "./../../Images/bg_sidebar_right.png";
import bgSidebarMobilier from "./../../Images/bg_sidebar_mobilier.png";
import bgSidebarImmobilier from "./../../Images/bg_sidebar_immobilier.png";

import "./SidebarRightFinancingRequestNotConnected.scss";

const SidebarRightFinancingRequestNotConnected = () => {
  const [dataSimulation, setDataSimulation] = React.useState([]);

  const { setIsLoading } = useLoader();

  React.useEffect(() => {
    setIsLoading(true);

    axios
      .get(`${process.env.REACT_APP_API_URL}/get-request-with-simulation`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          "Access-Token": localStorage.getItem(
            process.env.REACT_APP_LOCAL_STORAGE_KEY_TOKEN_OFFLINE
          ),
        },
      })
      .then((response) => {
        setIsLoading(false);
        setDataSimulation(response.data?.data || []);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }, [setIsLoading]);

  // A rendre Dynamique
  const request_type = dataSimulation?.simulation?.product_name || "-";

  return (
    <div className="wrap-sidebar-right">
      <div className="header-sidebar-right-notConnected">
        <img
          src={
            request_type === "immobilier"
              ? bgSidebarImmobilier
              : request_type === "mobilier"
              ? bgSidebarMobilier
              : bgSidebarRight
          }
          alt=""
          style={{ maxWidth: "100%", width: "100%" }}
        />
      </div>

      <div className="content-sidebar-right-notConnected connected-sidebar">
        <div className="title-content-sidebar-right">
          Résultat de la simulation
        </div>
        <div className="box-content-sidebar-right">
          <div className="subtitle-content-sidebar-right">
            Montant du loyer par mois
          </div>
          <div className="txt-content-sidebar-right price-sidebar">
            {addSeparateur(dataSimulation?.simulation?.result_amount) || "-"}{" "}
            TND
          </div>
          <p>Le taux appliqué au niveau du site est à titre indicatif</p>
        </div>
        <div className="box-content-sidebar-right">
          <div className="subtitle-content-sidebar-right">
            Type de bien à financer
          </div>
          <div className="txt-content-sidebar-right text-capitalize">
            {request_type}
          </div>
        </div>
        <div className="box-content-sidebar-right">
          <div className="subtitle-content-sidebar-right">Montant</div>
          <div className="txt-content-sidebar-right">
            {addSeparateur(dataSimulation?.simulation?.amount) || "-"} TND
          </div>
        </div>
        <div className="box-content-sidebar-right">
          <div className="subtitle-content-sidebar-right">Autofinancement</div>
          <div className="txt-content-sidebar-right">
            {addSeparateur(dataSimulation?.simulation?.self_financing) || "-"}{" "}
            TND
          </div>
        </div>
        <div className="box-content-sidebar-right">
          <div className="subtitle-content-sidebar-right">Durée</div>
          <div className="txt-content-sidebar-right">
            {dataSimulation?.simulation?.duration || "-"} Mois
          </div>
        </div>
      </div>

      <div className="footer-sidebar-right-notConnected">
        Assurez-vous de remplir chaque champ avec précision pour éviter tout
        retard dans le traitement de votre demande.
      </div>
    </div>
  );
};

export default SidebarRightFinancingRequestNotConnected;
